var map = {
	"./branding.png": "../../navigart-conf/img/branding/branding.png",
	"./logo1.gif": "../../navigart-conf/img/branding/logo1.gif",
	"./logo1.png": "../../navigart-conf/img/branding/logo1.png",
	"./logo2.png": "../../navigart-conf/img/branding/logo2.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./img/branding sync recursive ^\\.\\/.*$";